import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  IconButton, 
  Box, 
  useTheme
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { ThemeToggle } from '@/shared/ui';
import UserMenu from '@/widgets/UserMenu';

interface TopBarProps {
  drawerWidth: number;
  handleDrawerToggle: () => void;
  onLogout?: () => void;
  open?: boolean;
}

const TopBar: React.FC<TopBarProps> = ({ 
  drawerWidth, 
  handleDrawerToggle,
  onLogout,
  open 
}) => {
  const theme = useTheme();

  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
        zIndex: theme.zIndex.drawer + 1
      }}
      data-testid="topbar"
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: 'none' } }}
          data-testid="menu-button"
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
          CobroLink
        </Typography>
        
        {/* Theme toggle */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <ThemeToggle variant="icon" />
        </Box>
        
        {/* User menu */}
        <UserMenu onLogout={onLogout} />
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
